export const userImageSrc = (user: Odoo.User) => {
  if (user.image_512) {
    return `data:image/jpeg;base64,${user.image_512}`;
  }
  return undefined;
};

export const userInitials = (name: string) => {
  return name
    .split(' ')
    .map(word => word[0])
    .join('')
    .toUpperCase();
};
